<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row m-0">
                    <div class="col-12 p-0">
                        <div class="row p-0 m-0 align-items-start">
                            <!-- Image Section -->
                            <div class="col-12 col-md-5 p-0">
                                <div class="esim-img text-center">
                                    <img src="assets/images/xplorerCard/xplorer-card.png" class="img-fluid">
                                </div>
                            </div>

                            <!-- Features Section -->
<div class="col-12 col-md-7 p-0">
  <div class="feature-card position-relative">
    <!-- Background images -->
    <div class="d-none d-lg-block">
      <img src="/assets/images/xplorerCard/xplore-feature.png" 
           class="img-fluid w-100 rounded" 
           alt="Feature background">
    </div>

    <div class="d-lg-none">
      <img src="/assets/images/xplorerCard/xp-feature-bg.png" 
           class="img-fluid w-100 rounded" 
           style="height: 690px;"
           alt="Feature background">
    </div>

    <!-- Overlay content -->
    <div class="feature-content position-absolute top-0 start-0 w-100 h-100 p-4 d-flex flex-column justify-content-center">

      <!-- Title visible only on mobile -->
      <h3 class="xp-title text-white fw-bold  text-center w-100 d-block d-lg-none">
        Features of Xplorer Card
      </h3>

      <div class="row text-left">
        <!-- 3 items per row -->
        <div class="col-6 col-md-4 mb-1" *ngFor="let singleItem of menuItems">
          <div class="single-features d-flex flex-column align-items-start text-start">
            <img 
              src="/assets/images/xplorerCard/{{singleItem.icon}}" 
              class="feature-icon mb-1"
              alt="{{singleItem.title}}">
            <div class="features-title fw-100 text-white">
              {{singleItem.title}}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
